<template>
  <div class="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
    <slot name="default"></slot>
  </div>
</template>
